export default "__VITE_ASSET__CMOngbVj__"